import moment from "moment/moment";

export const columnConfig = [
  {
    name: "Transaction id",
    row: (item) => item?.TransactionId,
  },
  {
    name: "DATE",
    row: (item) => moment(item.Created * 1000).format("DD-MM-YYYY HH:mm"),
  },
  {
    name: "Withdrawal amount",
    row: (item) => item?.Amount,
  },
  {
    name: "Final balance",
    row: (item) => item?.Balance,
  },
];
